import * as React from 'react'
import { ExternalLinksWidgetCard, WidgetCardBaseProps } from "../../../../types"
import styled from 'styled-components'
import Icon from '../../../../components/Icons/Icon'
import Card from '../Card'

const Container = styled.div`
  display: flex;
  flex-direction: column;
`

const Item = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  font-size: 14px;
  line-height: 21px;
  min-width: 0px;
  font-weight: 500;
  cursor: pointer;

  &:only-child {
    padding: 0;
  }

  &:not(:last-child) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }

  svg {
    width: 16px;
    height: 16px;
  }
`

const Title = styled.div`
  margin-right: auto;
  flex: 1 1 0%;
  font-size: 14px;
  line-height: 21px;
  min-width: 0px;
  font-weight: 500;
  padding-right: 20px;
`

type IProps = WidgetCardBaseProps & {
  card: ExternalLinksWidgetCard
}
const ExternalLink = (props: IProps) => {
  const { card: { external_links } } = props

  const onClick = (link: { label: string, url: string }) => {
    window.open(link.url, '_blank', 'noopener,noreferrer')
  }

  if (external_links?.length === 0) return null

  return (
    <Card>
      <Container>
        {external_links.map((link, index) => (
          <Item key={index} onClick={() => onClick(link)}>
            <Title>{link.label}</Title>
            <Icon icon='messenger-external-link' />
          </Item>
        ))}
      </Container>
    </Card>
  )
}

export default ExternalLink